export default "__VITE_ASSET__CmOow0_J__"